import React from 'react';
import { Card } from 'react-bootstrap';

/**
 * One KPI tile: big number, label, accent icon, optional detail line. Clickable
 * when it stands for a view the agent can jump to; `active` marks the tile
 * whose view is currently shown.
 */
function InvoicingKpi({
  label, value, icon, accent, detail = '', title = '', onClick = null, active = false,
}) {
  const body = (
    <Card.Body className="d-flex align-items-center gap-3 py-3">
      <span
        className="d-inline-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
        style={{
          width: 44, height: 44, background: `${accent}1a`, color: accent,
        }}
        aria-hidden="true"
      >
        <i className={`fa ${icon}`} />
      </span>
      <div className="text-start min-w-0">
        {/* Compacted values (€12.1K) keep the exact figure a hover away. */}
        <div className="fs-4 fw-semibold lh-1 text-truncate" title={title || undefined}>{value}</div>
        <div className="text-muted small">{label}</div>
        {detail && <div className="text-muted text-truncate" style={{ fontSize: '.72rem' }}>{detail}</div>}
      </div>
    </Card.Body>
  );
  const className = `border-0 shadow-sm h-100 w-100 text-start${active ? ' invoicing-kpi-active' : ''}`;
  if (!onClick) return <Card className={className}>{body}</Card>;
  return (
    <Card
      as="button"
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={className}
      style={{ cursor: 'pointer' }}
    >
      {body}
    </Card>
  );
}

export default InvoicingKpi;
